module.exports = __webpack_public_path__ + "img/Talk Graphic 10 - COC.7e85d97d.png";